import { useState, useMemo, useEffect, useRef } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import dayjs from "dayjs";

import api from "../api/api";
import { whitedelete } from "../utils/svgs/svgcode";
import { externalapi } from "../api/externalapi";
import { drag } from "./svg";
import SendToEmrDocument from "./modals/sendtoemr";
import SendToAthena from "./modals/sendtoathena";
import { useSelector } from "react-redux";
import RefreshIcon from '@mui/icons-material/Refresh';
import axios from "axios";
import ToastMessage from "../utils/mui/righttoptoast";
const statusChip = (rawStatus, { active = false } = {}) => {
  const code = (rawStatus || "").toUpperCase().trim();

  const map = {
    READ: {
      label: "Read",
      cls: "text-[#232323] bg-[#FFFFFF] border border-[#E5E7EB]",
    },
    UNREAD: {
      label: "Unread",
      cls: "text-[#E17954] bg-[#FFF5F5] border border-[#E17954]",
    },
  };

  const s = map[code] || { label: "—", cls: "text-[#667085] bg-[#E7E9F0]" };

  const activeCls = active
    ? "bg-[#FFFFFF1A] text-white border border-white/40"
    : "";

  return (
    <span
      className={`px-3 py-[3px] rounded-full text-xs font-medium ${s.cls} ${activeCls}`}
    >
      {s.label}
    </span>
  );
};

const FaxTable = ({ loading, fax, fetchFax }) => {
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
const [openMenuId, setOpenMenuId] = useState(null);
const menuRef = useRef(null);
  // Selection and detail states
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFaxId, setSelectedFaxId] = useState(null);
  const [selectedFax, setSelectedFax] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [documentUrl, setDocumentUrl] = useState();
const [iscollapse,setIsCollapse]=useState(!false)
const[emrModal,setEmrModal]=useState(false)
 const taskscreenprev = useSelector((state) => state.userPrivileges.taskrpm);
const[athenaModal,setAthenaModal]=useState(false)
const practiseid = window.getPracticeId();
const [currentIndex, setCurrentIndex] = useState(0);
 const handleToastClose = () => {
    setOpenToast(false);
  };
       const [toastSeverity, setToastSeverity] = useState('success');
   const [openToast, setOpenToast] = useState(false);
      const [toastMessage, setToastMessage] = useState('');
  const totalPages = Math.ceil((fax?.length || 0) / itemsPerPage);
  const paginatedData = useMemo(
    () =>
      fax?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      ) || [],
    [fax, currentPage, itemsPerPage]
  );


useEffect(() => {
  function handleClickOutside(e) {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpenMenuId(null);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

  // Handlers
  // const handlePrev = () => currentPage > 1 && setCurrentPage((p) => p - 1);
  // const handleNext = () =>
  //   currentPage < totalPages && setCurrentPage((p) => p + 1);

  const handlePrev = () => {
  if (currentPage > 1) {
    setCurrentPage((prevPage) => prevPage - 1);
  }
};
const handleNext = () => {
  if (currentPage < totalPages) {
    setCurrentPage((prevPage) => prevPage + 1);
  }
};

const handleRowPrev = () => {
  // const currentIndex = paginatedData.findIndex(item => item.id === selectedFaxId);
  // if (currentIndex > 0) {
  //   const prevFaxItem = paginatedData[currentIndex - 1];
  //   selectFax(prevFaxItem); // Select the previous row
  // }
  const currentIndex = fax.findIndex(item => item.id === selectedFaxId);
  if (currentIndex > 0) {
    const prevFaxItem = fax[currentIndex - 1];
    selectFax(prevFaxItem);
    
    // Optionally, adjust page if we move to the previous page (e.g., if the row is from a previous page)
    if (currentIndex % itemsPerPage === 0) {
      setCurrentPage(prevPage => prevPage - 1); // Move to previous page if we're at the start of a page
    }
  }else{
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  }
};

const handleRowNext = () => {
  // const currentIndex = paginatedData.findIndex(item => item.id === selectedFaxId);
  // if (currentIndex < paginatedData.length - 1) {
  //   const nextFaxItem = paginatedData[currentIndex + 1];
  //   selectFax(nextFaxItem); // Select the next row
  // }
  const currentIndex = fax.findIndex(item => item.id === selectedFaxId);
  if (currentIndex < fax.length - 1) {
    const nextFaxItem = fax[currentIndex + 1];
    selectFax(nextFaxItem);

    // Optionally, adjust page if we move to the next page (e.g., if the row is from the next page)
    if ((currentIndex + 1) % itemsPerPage === 0) {
      setCurrentPage(prevPage => prevPage + 1); // Move to next page if we're at the end of a page
    }
  }else{
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  }
};

  const handlePerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const selectFax = (faxItem) => {
    setSelectedFaxId(faxItem.id);
    setSelectedFax(faxItem);
    viewAttachment(faxItem);
  };

  const viewAttachment = async (item) => {
    const obj = {
      extensionid: item.extensionId,
      attachmentid: item.attachments[0].id,
      messageid: item.id,
    };

    setIsLoading(true);

    try {
      const res = await api.get(
        `/v1/${practiseid}/fax/check-filepath?extentionid=${item.extensionId}&messageid=${item.id}`
      );
      if (res.status === 200 && res.totalcount > 0 && res.data[0].filepath) {
          const pdfUrl = res.data[0].filepath;
          setDocumentUrl(pdfUrl);
        }else{
          const response = await externalapi.post("/ringcentral/fax/viewdoc/", obj);
          if (response.data.result === "true" && response.data.documenturl) {
            const pdfUrl = response.data.documenturl;

              // update filepath in DB
              const updateObj = {
                extensionid: item.extensionId,
                messageid: item.id,
                filepath: pdfUrl
              };

              await api.put(
                `/v1/${practiseid}/fax/updatepath`,
                updateObj
              );

            setDocumentUrl(pdfUrl);
            // window.open(pdfUrl, "_blank"); // opens PDF in a new tab
          }
        }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const openDeleteModal = (item) => {
    setSelectedFax(item);
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
    setSelectedFax(null);
  };
const handlerefresh = async () => {
  try {
    setIsLoading(true);

    const response = await axios.post(
      "/chimlw/fax/refresh/?bmkxeyjfqpwapjqedzj"
    );

    if (response.status === 200) {
      const { success = 0, failed = 0 } = response.data || {};

      // always show success count (even 0)
      setToastMessage(`${success} fax synced`);
      setToastSeverity("success");
      setOpenToast(true);

      // optional: if failed also show extra info
      if (failed > 0) {
        setToastMessage(`${success} synced, ${failed} failed`);
        setToastSeverity("warning");
        setOpenToast(true);
      }
    }
  } catch (error) {
    console.log(error);
    setToastMessage("Fax refresh failed");
    setToastSeverity("error");
    setOpenToast(true);
  } finally {
    setIsLoading(false);
    fetchFax();
  }
};


  const handleDelete = async () => {
    if (!selectedFax) return;

    const obj = {
      extentionid: selectedFax.extensionId,
      messageid: selectedFax.id,
    };

    setIsLoading(true);

    try {
      await api.post(`/v1/${practiseid}/fax/delete?extentionid=${selectedFax.extensionId}&messageid=${selectedFax.id}`);
      fetchFax(true);
      setSelectedFaxId(null);
      setSelectedFax(null);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      closeDeleteModal();
    }
  };

  useEffect(() => {
    if (fax?.length) setCurrentPage(1);
  }, [fax?.length]);

  return (
    <div className="w-full rounded-[20px] bg-[#FFF] p-2">
       <div className="w-full border-b border-[#E5E7EB] flex justify-between items-center mb-4 text-start p-2 px-3 pb-4 ">
                 {/* <div className="flex items-center gap-2">


                   <div className="text-[16px] font-normal font-inter text-[#232323]">
               View Details       </div>
               <div className="cursor-pointer"
          onClick={handlerefresh}
          ><RefreshIcon/></div>
                 </div> */}
                   



                       <div
  className="cursor-pointer"
  onClick={() => setIsCollapse(!iscollapse)}
>
  {drag(iscollapse ? "green" : "#e17954")}
</div>

                </div>
      {/* Master–Detail Split */}
      <div className="w-full flex gap-4 min-h-[60vh] max-h-[82vh]">
        {/* LEFT: list */}
         <div className={`w-full ${iscollapse?"sm:w-[18%]":"sm:w-[38%]"} flex flex-col`}>
          {!iscollapse&&<div className="flex items-center justify-between px-2 py-2 text-sm text-[#667085]">
            <div>Total: {fax?.length || 0}</div>
            <div className="flex items-center gap-2">
              <span>Per Page:</span>
              <select
                value={itemsPerPage}
                onChange={handlePerPageChange}
                className="border rounded-md px-2 py-1 text-[#1d2951]"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
              </select>
            </div>
          </div>}

          <div className="flex-1 min-h-0 overflow-y-auto pr-1">
            {loading ? (
              <div className="w-full py-10 text-center text-gray-500">
                Loading...
              </div>
            ) : paginatedData.length === 0 ? (
              <div className="w-full py-10 text-center text-gray-500">
                No Data Available
              </div>
            ) : (
              <ul className="space-y-3">
                {paginatedData.map((faxItem, idx) => {
                  const isActive = selectedFaxId === faxItem.id;
                  return (
                    <li
                      key={faxItem.id}
                      className={`rounded-[10px] border border-[#E5E7EB] hover:bg-[#F8FAFC] transition-all cursor-pointer ${
                        isActive
                          ? "!bg-[#50869A] text-white shadow-md"
                          : "bg-white"
                      }`}
                      onClick={() => selectFax(faxItem)}
                    >
                      <div className="flex items-start gap-4 p-2">
                        <div
                          className={`flex text-sm font-medium font-inter ${
                            isActive ? "text-white" : "text-black"
                          }`}
                        >
                          {(currentPage - 1) * itemsPerPage + idx + 1}
                        </div>

                        <div className="flex-1 min-w-0">
                          <div className="flex flex-col items-start justify-start gap-1">
                            <div
                              className={`truncate font-medium font-inter text-xs ${
                                isActive ? "text-[#FFFFFF]" : "text-[#232323]"
                              }`}
                            >
                              {faxItem?.from?.name || "N/A"}
                            </div>
                            <div className="flex justify-between w-full">


                                               <div
                              className={`truncate font-inter text-[10px] font-normal ${
                                isActive ? "text-[#FFFFFFCC]" : "text-[#7E7E7E]"
                              }`}
                            >
                              {faxItem?.from?.phoneNumber || "Fax"}
                            </div>
                            {iscollapse && (
  <div className="relative">
    {/* 3 clickable dots */}
    <div
      className="flex items-center gap-[3px] cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenuId(openMenuId === faxItem.id ? null :faxItem.id);
      }}
    >
      <div className={`w-[6px] h-[6px] ${isActive ? 'bg-white' : 'bg-[#7E7E7E]'} rounded-full`} />
      <div className={`w-[6px] h-[6px] ${isActive ? 'bg-white' : 'bg-[#7E7E7E]'} rounded-full`} />
      <div className={`w-[6px] h-[6px] ${isActive ? 'bg-white' : 'bg-[#7E7E7E]'} rounded-full`} />
    </div>
{openMenuId === faxItem.id && (
  <div
    ref={menuRef}
    className="absolute right-0 top-5 text-start bg-white border shadow-md rounded-md text-xs z-50 w-[100px]"
    onClick={(e) => e.stopPropagation()}
  >
    <div
      className="px-3 py-2 text-[#232323] hover:bg-gray-100 cursor-pointer"
      onClick={(e) => {
                              e.stopPropagation();
                              window.open(documentUrl, "_blank");
                            }}
    >
      View
    </div>

    <div
      className="px-3 py-2 text-red-600 hover:bg-gray-100 cursor-pointer"
     onClick={(e) => {
                              e.stopPropagation();
                              openDeleteModal(faxItem);
                            }}
    >
      Delete
    </div>
  </div>
)}

  </div>
)}    
                            </div>
       
                            {!iscollapse&&<div
                              className={`text-[10px] font-inter font-normal ${
                                isActive ? "text-[#FFFFFFCC]" : "text-[#7E7E7E]"
                              }`}
                            >
                              {dayjs(faxItem.creationTime).format(
                                "MM-DD-YYYY h:mm A"
                              )}
                            </div>}
                          </div>
                        </div>

                       {!iscollapse&& <div className="flex items-center gap-3">
                          {statusChip(faxItem.readStatus, { active: isActive })}
                          <RemoveRedEyeOutlinedIcon
                            fontSize="small"
                            className={`${
                              isActive ? "text-white" : "text-[#6B7280]"
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(documentUrl, "_blank");
                            }}
                          />
                          <DeleteOutlineIcon
                            fontSize="small"
                            className={`${
                              isActive ? "text-white/80" : "text-[#9CA3AF]"
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              openDeleteModal(faxItem);
                            }}
                          />
                        </div>}
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>

          {/* Pagination (left pane footer) */}
          {fax?.length > 0 && (
            <div className="flex items-center justify-between mt-3 px-2 py-2">
              <button
                onClick={handlePrev}
                disabled={currentPage === 1}
             className={`${
  iscollapse ? "px-3 py-2 text-xs" : "px-3 py-[4px] text-sm"
} rounded-md text-white ${
  currentPage ===1
    ? "bg-gray-400 cursor-not-allowed"
    : "bg-[#1d2951]"
}`}

              >
                Prev
              </button>
              <span className="text-xs text-[#667085]">
                {currentPage} of {totalPages || 1}
              </span>
              <button
                onClick={handleNext}
                disabled={currentPage === totalPages || totalPages === 0}
            className={`${
  iscollapse ? "px-3 py-2 text-xs" : "px-3 py-[4px] text-sm"
} rounded-md text-white ${
  currentPage === totalPages || totalPages === 0
    ? "bg-gray-400 cursor-not-allowed"
    : "bg-[#1d2951]"
}`}

              >
                Next
              </button>
            </div>
          )}
        </div>

        {/* RIGHT: detail view */}
        <div className="flex-1 min-w-0  bg-white">
        

          {/* HEADER + ACTION BAR (replaces your current header div) */}
          <div className="w-full ">
           
            {/* Second row: prev/next (left) + actions (right) */}
            <div className="p-3 flex items-center justify-between">
              {/* Left controls */}
              <div className="flex items-center gap-2">
                {/* Previous Button */}
                <button
                  type="button"
                  onClick={handleRowPrev}
                  disabled={currentPage === 0 || !selectedFax}
                  className={`px-3 py-[2px] rounded-lg text-[14px] font-medium border-[1px] transition
                    text-[#2B7FFF] border-[#2B7FFF] bg-white ${currentPage === 1 ? "cursor-not-allowed" : ""}`}
                >
                  <span className="mr-1 text-[#2B7FFF]">‹</span> Previous
                </button>

                {/* Pagination Text */}
                {/* <span className="text-xs text-[#667085]">
                  {currentPage} of {totalPages || 1}
                </span> */}

                {/* Next Button */}
                <button
                  type="button"
                  onClick={handleRowNext}
                  disabled={currentPage > totalPages}
                  className={`px-3 py-[2px] rounded-lg text-[14px] font-medium border-[1px] transition
                    text-[#2B7FFF] border-[#2B7FFF] bg-white ${currentPage >= totalPages ? "cursor-not-allowed" : ""}`}
                >
                  Next <span className="ml-1 text-[#2B7FFF]">›</span>
                </button>
              </div>

              {/* Right actions */}
              <div className="flex items-center gap-2">

 {selectedFax && taskscreenprev?.includes("send to athena") &&<button
                  type="button"
                                 onClick={() =>   setAthenaModal(true)}
                  className="px-3 py-[2px] rounded-lg text-[14px] font-inter font-normal border-[1px] transition
                   text-[#A980EA] border-[#A980EA] bg-white"
                >
                  Send to Athena
                </button>}


               {selectedFax && taskscreenprev?.includes("send to emr") && (
  <button
    type="button"
    onClick={() => setEmrModal(true)}
    className="px-3 py-[2px] rounded-lg text-[14px] font-inter font-normal
               border-[1px] transition
               text-[#50869A] border-[#50869A] bg-white"
  >
    Send to EMR
  </button>
)}
                <button
                  type="button"
                  onClick={() => openDeleteModal(selectedFax)}
                  className="px-3 py-[2px] rounded-lg text-[14px] font-inter font-normal border-[1px] transition
                   text-[#FB2C36] border-[#FB2C36]"
                >
                  Delete Fax
                </button>
              </div>
            </div>
          </div>

          {/* body */}
          <div className="p-3">
            <div className="h-[62vh] bg-[#F3F4F6] rounded-xl p-3 overflow-auto">
              {selectedFax ? (
                selectedFax ? (
                  // When document URL is already loaded
                  <iframe
                    src={documentUrl}
                    title="Fax Document"
                    className="w-full h-full rounded-lg border border-[#E5E7EB]"
                  />
                ) : (
                  // Show button until document is loaded
                  <div className="space-y-4">
                    <div className="flex justify-center gap-4">
                      <button
                        onClick={() => viewAttachment(selectedFax)}
                        className="px-4 py-2 bg-[#E17954] text-white rounded-md hover:bg-[#d16a47] transition-colors flex items-center gap-2"
                      >
                        <VisibilityIcon style={{ fontSize: "18px" }} />
                        View Document
                      </button>
                    </div>
                    <div className="text-center text-[#98A2B3]">
                      Select "View Document" to open the fax attachment
                    </div>
                  </div>
                )
              ) : (
                <div className="h-full w-full flex items-center justify-center text-[#98A2B3]">
                  Select a fax from the list to view details.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Loading Spinner for detail fetch */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
   <SendToEmrDocument
              // data={data}
             setsubview={()=>{
              console.log('done')
             }}
  open={emrModal}
selectedFax={selectedFax}
  onClose={() => setEmrModal(false)}
  
  
/>
  <SendToAthena
              // data={data}
             setsubview={()=>{
              console.log('done')
             }}
  open={athenaModal}
selectedFax={selectedFax}
  onClose={() => setAthenaModal(false)}
  
  
/>
      {/* Delete Confirmation Modal */}
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 ${
          deleteModalOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50"
          onClick={closeDeleteModal}
        ></div>

        {/* Modal Content */}
        <div className="relative bg-white text-start rounded-lg shadow-xl w-full max-w-md mx-4 p-6">
          {/* Dialog Title */}
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Confirm Delete
          </h2>

          {/* Dialog Content */}
          <div className="mb-6">
            <p className="text-gray-600">
              Are you sure you want to delete this fax? This action cannot be
              undone.
            </p>
          </div>

          {/* Dialog Actions */}
          <div className="flex justify-end gap-3">
            <button
              onClick={closeDeleteModal}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleDelete}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              autoFocus
            >
              Delete
            </button>
          </div>
        </div>
      </div>

      
                      <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
    </div>
  );
};

export default FaxTable;